/**
 * Photo Log upload file-type rules (HERA-8709).
 * Only formats that work everywhere a photo log photo is used are allowed:
 * Hera view, Athena photo log drawer, Hera AI review (OpenAI) and compression.
 * SVG, HEIF, GIF, TIFF, BMP and AVIF are rejected. See .kiro/specs/HERA-8709.
 */
export const PHOTO_LOG_ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png', 'image/heic', 'image/webp']
export const PHOTO_LOG_ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png', 'heic', 'webp']
export const PHOTO_LOG_ACCEPT = '.jpg,.jpeg,.png,.heic,.webp,image/jpeg,image/png,image/heic,image/webp'
export const PHOTO_LOG_FORMATS_HINT = 'JPG, PNG, HEIC or WebP'
const FORMATS_SENTENCE = 'Only JPG, PNG, HEIC and WebP photos can be uploaded.'

export function isAllowedPhotoFile(file) {
  if (!file) return false
  const type = (file.type || '').toLowerCase()
  // A real browser type decides. Empty or octet-stream (HEIC on Windows / some Android) falls back to the extension.
  if (type && type !== 'application/octet-stream') return PHOTO_LOG_ALLOWED_MIME_TYPES.includes(type)
  const name = file.name || ''
  const ext = name.includes('.') ? name.split('.').pop().toLowerCase() : ''
  return PHOTO_LOG_ALLOWED_EXTENSIONS.includes(ext)
}

export function getPhotoTypeRejectionMessage(rejectedNames = []) {
  const names = rejectedNames.filter(Boolean)
  if (names.length >= 3) return `${names.length} files weren't added. ${FORMATS_SENTENCE}`
  if (names.length === 2) return `${names[0]} and ${names[1]} weren't added. ${FORMATS_SENTENCE}`
  if (names.length === 1) return `${names[0]} wasn't added. ${FORMATS_SENTENCE}`
  return FORMATS_SENTENCE
}
